import { createPermissionGuard } from './permissionGuard';
import { createTitleGuard } from './titleGuard';

export function createGuard(router) {
  createPermissionGuard(router);
  createTitleGuard(router);
}
